// How a business reaches its agreement with Afriex.
export var BusinessAgreementPath;
(function (BusinessAgreementPath) {
    // The standard MSA, signed by the owner in the business portal.
    BusinessAgreementPath["Standard"] = "STANDARD";
    // Negotiated terms: Afriex shares a custom agreement, and the business
    // uploads its signed copy.
    BusinessAgreementPath["Negotiated"] = "NEGOTIATED";
})(BusinessAgreementPath || (BusinessAgreementPath = {}));
//# sourceMappingURL=BusinessAgreementPath.js.map